import React from 'react';
import { Box, Flex, Text, Button, Image, VStack, useDisclosure, Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import postJobImage from '../../assets/createjob2.png';
import PostJob from '../../components/provider/postJob'; // Ensure this is the correct path to your postJob component

const PostJobComponent = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {/* Main Component */}
      <Flex 
        direction={{ base: 'column', md: 'row' }} 
        align="center" 
        justify="center"  // Add this line to center the VStack within the Flex container
        p={1} 
        bg="#F5F6F8" 
        boxShadow="md"
        borderRadius="md"
        maxW="1500px" 
        width="100%"  
        mx="0"    
        height="200px"
        position="relative"  // Ensure child elements (image and content) are positioned relative to this container
      >
         {/* Image Section with Reduced Opacity */}
         <Box 
          position="absolute" 
          top="0" 
          left="0" 
          width="100%" 
          height="100%" 
          zIndex="1" 
          opacity="0.4" // Reduce the opacity of the image
        >
          <Image 
            src={postJobImage} 
            alt="Post a job"
            boxSize="100%" 
            objectFit="cover" 
            borderRadius="md" 
          />
        </Box>
        {/* Left Side: Text Section */}
        <VStack 
          align="center" 
          justify="center"  
          spacing={6} 
          maxW="600px" 
          width={{ base: '100%', md: '50%' }}  // Full width on small screens, half width on medium+
          height="100%"
          textAlign="center"
          flex="1" 
          p={4} 
          borderRadius="md"
          zIndex="2"  // Ensure content appears above the image
        >
          <Text 
            fontSize={{ base: "xl", md: "2xl" }} 
            fontWeight="bold" 
            color="gray.700" 
            lineHeight="1.3" 
          >
            "Post a job today and access a network of top-tier professionals, ready to deliver excellence and support your success."
          </Text>
          <Button 
            backgroundColor="blue.500" 
            color="white" 
            size="lg" 
            width={{ base: "250px", md: "400px" }} // Smaller button width for mobile
            // width="400px" 
            height="45px" 
            _hover={{ backgroundColor: '#135BB4' }} 
            onClick={onOpen}  // Open popup when button is clicked
          >
            Post a Job
          </Button>
        </VStack>

        {/* Right Side: Image Section
        <Box ml={{ base: "0", md: "350px" }}>
          <Image 
            src={postJobImage} 
            alt="Post a job" 
            borderRadius="md" 
            boxSize={{ base: "250px", md: "300px" }} 
            objectFit="cover" 
          />
        </Box> */}
      </Flex>

        {/* Popup Modal */}
        <Modal 
        isOpen={isOpen} 
        onClose={onClose} 
        size="4xl" 
        closeOnOverlayClick={false}  // Prevent closing when clicking outside
        closeOnEsc={false}           // Prevent closing with Esc key
      >
        <ModalOverlay backdropFilter="blur(10px)" bg="rgba(0, 0, 0, 0.3)" /> {/* Blurs the background when modal is open */}
        <ModalContent maxW="1100px">
          <ModalBody p={0}>
            {/* Render the PostJob component inside the modal */}
            <PostJob onClose={onClose} /> {/* Pass onClose prop to close modal after submission */}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PostJobComponent;
